const TICKS_PER_SECOND = 10000000
const LONG_PAUSE_SECONDS = 3

// 把一段录音里 Azure 分段返回的识别结果合成一份：分数按每段词数加权，停顿按相邻两个词的间隔算
export function summarizeSpeech(segments, durationSeconds) {
  const scored = segments
    .map(detail => ({ text: detail.DisplayText || '', best: detail.NBest?.[0] }))
    .filter(segment => segment.text && segment.best)
  const transcript = scored.map(segment => segment.text).join(' ')
  const wordCount = transcript.split(/\s+/).filter(Boolean).length
  const words = scored.flatMap(segment => segment.best.Words || [])
  const timedWords = words.filter(word => Number.isFinite(word.Offset) && Number.isFinite(word.Duration) && word.Duration > 0)
  const speechDurationSeconds = timedWords.length
    ? (Math.max(...timedWords.map(word => word.Offset + word.Duration)) - Math.min(...timedWords.map(word => word.Offset))) / TICKS_PER_SECOND : 0

  const weighted = name => {
    let total = 0
    let weight = 0
    scored.forEach(({ best }) => {
      const value = best.PronunciationAssessment?.[name]
      const count = best.Words?.length || 0
      if (typeof value === 'number' && count) {
        total += value * count
        weight += count
      }
    })
    return weight ? Math.round(total / weight) : null
  }

  let longPauses = 0
  for (let index = 1; index < words.length; index += 1) {
    const previousEnd = words[index - 1].Offset + words[index - 1].Duration
    if ((words[index].Offset - previousEnd) / TICKS_PER_SECOND > LONG_PAUSE_SECONDS) longPauses += 1
  }

  return {
    transcript,
    wordCount,
    durationSeconds: Math.round(durationSeconds * 10) / 10,
    speechDurationSeconds: Math.round(speechDurationSeconds * 100) / 100,
    pronunciation: weighted('PronScore'),
    accuracy: weighted('AccuracyScore'),
    fluency: weighted('FluencyScore'),
    completeness: weighted('CompletenessScore'),
    wordsPerMinute: speechDurationSeconds > 0 && wordCount ? Math.round(wordCount / (speechDurationSeconds / 60)) : 0,
    longPauses
  }
}
